import React, { createContext, useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";

export const userContext = createContext();

const UserContextProvider = ({ children }) => {
  const [user, setUser] = useState({
    access_token: "",
    expires: "",
    refresh_token: "",
  });

  const [person, setPerson] = useState({
    id: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    tfa_secret: null,
    balance: "",
    balance_id: "",
    companyname: "",
    role: "",
    avatar: "",
    service_rights: [],
  });

  const [cgrate, setCgrate] = useState({
    balance: "",
  });

  const [branch, setBranch] = useState({});

  const history = useHistory();
  const logoutTimerRef = useRef(null);

  const logout = () => {
    if (logoutTimerRef.current) {
      clearTimeout(logoutTimerRef.current);
      logoutTimerRef.current = null;
    }
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("expires");
    localStorage.removeItem("expires_at");
    localStorage.removeItem("role");
    setUser({ access_token: "", expires: "", refresh_token: "" });
    history.push("/sign-in");
  };

  const scheduleAutoLogout = (msRemaining) => {
    if (logoutTimerRef.current) {
      clearTimeout(logoutTimerRef.current);
      logoutTimerRef.current = null;
    }
    if (msRemaining <= 0) {
      logout();
      return;
    }
    logoutTimerRef.current = setTimeout(logout, msRemaining);
  };

  const updateCgrate = () => {
    const accessToken = localStorage.getItem("access_token");
    axios
      .get(`${process.env.REACT_APP_SERVER}/operation/mainbalance`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        setCgrate({
          balance: response.data.balance,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const updateUser = async (values) => {
    try {
      const loginPayload = {
        email: values.email,
        password: values.password,
      };
      if (values.otp) {
        loginPayload.otp = values.otp;
      }

      const response = await axios.post(
        "https://cms.paysmart.co.zm/auth/login",
        loginPayload,
      );

      const { access_token, expires, refresh_token } = response.data.data;
      const expiresAt = Date.now() + expires;
      localStorage.setItem("access_token", access_token);
      localStorage.setItem("refresh_token", refresh_token);
      localStorage.setItem("expires", expires);
      localStorage.setItem("expires_at", String(expiresAt));

      setUser({ access_token, expires, refresh_token });
      scheduleAutoLogout(expires);

      const userResponse = await axios.get(
        "https://cms.paysmart.co.zm/users/me?fields=*,balance.*",
        { headers: { Authorization: `Bearer ${access_token}` } },
      );

      const data = userResponse.data.data;
      setPerson({
        id: data.id,
        status: data.status,
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        phone: data.phone,
        tfa_secret: data.tfa_secret,
        balance: data.balance[0].balance,
        balance_id: data.balance[0].id,
        companyname: data.companyname,
        role: data.role,
        service_rights: data.service_rights,
        avatar: data.avatar,
      });
      localStorage.setItem("role", data.role);

      axios
        .get(`${process.env.REACT_APP_SERVER}/operation/mainbalance`, {
          headers: { Authorization: `Bearer ${access_token}` },
        })
        .then((res) => setCgrate({ balance: res.data.balance }))
        .catch((err) => console.log(err));

      return {
        success: true,
        tfaEnabled: !!data.tfa_secret,
        accessToken: access_token,
      };
    } catch (error) {
      const directusError = error.response?.data?.errors?.[0];
      const code = directusError?.extensions?.code;
      if (code === "INVALID_OTP") {
        return { success: false, otpRequired: true };
      }
      return {
        success: false,
        error: directusError?.message || "Invalid email or password",
      };
    }
  };

  const generateTfa = async (password) => {
    const accessToken = localStorage.getItem("access_token");
    const response = await axios.post(
      "https://cms.paysmart.co.zm/users/me/tfa/generate",
      { password },
      { headers: { Authorization: `Bearer ${accessToken}` } },
    );
    return response.data.data;
  };

  const enableTfa = async (secret, otp) => {
    const accessToken = localStorage.getItem("access_token");
    await axios.post(
      "https://cms.paysmart.co.zm/users/me/tfa/enable",
      { secret, otp },
      { headers: { Authorization: `Bearer ${accessToken}` } },
    );
  };

  useEffect(() => {
    const expiresAt = localStorage.getItem("expires_at");
    if (expiresAt) {
      const msRemaining = parseInt(expiresAt, 10) - Date.now();
      if (msRemaining <= 0) {
        logout();
      } else {
        scheduleAutoLogout(msRemaining);
      }
    }
    return () => {
      if (logoutTimerRef.current) {
        clearTimeout(logoutTimerRef.current);
        logoutTimerRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <userContext.Provider
        value={{
          user,
          person,
          cgrate,
          updateUser,
          setPerson,
          branch,
          setBranch,
          updateCgrate,
          generateTfa,
          enableTfa,
          logout,
        }}
      >
        {children}
      </userContext.Provider>
    </React.Fragment>
  );
};

export default UserContextProvider;
